import type { IRequestsFindFilter } from '../../../interfaces/requestsFindFilter';
import type { ISearchFilter } from '../requestsList/RequestsListHeader';
import { UrlBuilder } from '../../../../../common/utils/urlBuilder';

export function buildGroupedWorklistUrl(searchFilter: ISearchFilter, filter: IRequestsFindFilter) {
    const urlBuilder = new UrlBuilder<IGroupedWorklistUrlParams>('/api/requests/closedGroupedWorklist');

    addSearchFilters(searchFilter, filter, urlBuilder);

    return urlBuilder.build();
}

export function addSearchFilters(searchFilter: ISearchFilter, filter: IRequestsFindFilter, urlBuilder: UrlBuilder) {
    if (searchFilter.practitionerId) {
        urlBuilder.add('practitionerId', searchFilter.practitionerId);
    }
    if (searchFilter.serviceId) {
        urlBuilder.add('serviceId', searchFilter.serviceId);
    }

    if (filter.text) {
        urlBuilder.add('text', filter.text);
        urlBuilder.add('filter', filter.text);
    }
    if (filter.processId) {
        urlBuilder.add('processId', filter.processId.replace(/^[a-zA-Z]*/, '').toUpperCase());
        urlBuilder.add('filter', filter.processId);
    }

    if (filter.birthDate) {
        urlBuilder.add('birthDate', filter.birthDate);
        urlBuilder.add('filter', filter.birthDate);
    }
}

export interface IGroupedWorklistUrlParams {
    birthDate?: string;
    filter?: string;
    processId?: string;
    text?: string;
}
